import React from 'react'
import { PropTypes } from 'prop-types'
import { Card, Transition } from 'semantic-ui-react'
import './pop-down-card.css'


const propTypes = {
  visible: PropTypes.bool.isRequired,
  header: PropTypes.string,
  description: PropTypes.string,
}
const defaultProps = { description: '', header: '' }

const PopDownCard = (props) => {
  const { visible, header, description } = props
  return (
    <div className="popDownCardContainer">
      <Transition visible={visible} animation='fly down' duration={500}>
        <Card>
          <Card.Content>
            <Card.Header className="popDownCardHeader">{header}</Card.Header>
            <Card.Description className="popDownCardDescription">
              {description}
            </Card.Description>
          </Card.Content>
        </Card>
      </Transition>
    </div>
  )
}

PopDownCard.propTypes = propTypes
PopDownCard.defaultProps = defaultProps

export default PopDownCard
